import styled from 'styled-components';
import { COLORS } from 'utils/styles';
import { deviceMax } from 'utils/styles/breakpoints';

export const EmailModal = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  background-color: ${COLORS.overlay};
  z-index: 20;
  padding-top: 100px;
  padding-bottom: 100px;
`;

export const CloseModal = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 18;
`;

export const ModalContainer = styled.div`
  width: 450px;
  margin: auto;
  position: relative;
  border-radius: 12px;
  z-index: 19;

  @media only screen and ${deviceMax.desktop} {
    width: 400px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 290px;
  }
`;

export const ForgotPasswordBlock = styled.div`
  width: 450px;
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );
  border: 1px solid rgba(15, 66, 90, 0.33);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 16px;
  margin-top: 60px;
  margin-bottom: 100px;
  @media only screen and ${deviceMax.desktop} {
    width: 400px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 290px;
  }
`;
